import localforage from 'localforage';
import { isNull } from 'app/utils/validators';

import uuid from 'uuid';

class LocalForage {
  static Key = {
    storyAdCommentHideUntil: 'storyAdCommentHideUntil',
    storyAdReviewHideUntil: 'storyAdReviewHideUntil',
    disableAppReviewUntilDate: 'disableAppReviewUntilDate',
    episodeCount: 'episodeCount',
    readEpisodes: 'readEpisodes',
    theme: 'theme',
    storyAdFirstUntil: 'storyAdFirstUntil',
  };

  static getInstance() {
    return localStorage;
  }

  static async setObjectValue(key, objectKey, value) {
    const obj = await LocalForage.getItem(key);

    return localforage
      .setItem(key, {
        ...obj,
        [objectKey]: value,
      })
      .catch((err) => console.error(err));
  }

  static async setEpisodeCount(storyId, episodeCount) {
    const episodeCounts = await LocalForage.getItem('episodeCount');

    return localforage
      .setItem('episodeCount', {
        ...episodeCounts,
        [storyId]: episodeCount,
      })
      .catch((err) => console.error(err));
  }

  static async convertEpisodeCount() {
    const setItems = {};

    Object.keys(localStorage).forEach((key) => {
      if (!key.indexOf('episodeCount')) {
        const storyId = key.split(':')[1];
        const _episodeCount = localStorage.getItem(key) || 0;
        setItems[storyId] = parseInt(_episodeCount, 10);
        localStorage.removeItem(key);
      }
    });
    const episodeCount = await LocalForage.getItem('episodeCount');
    const _item = {
      ...episodeCount,
      ...setItems,
    };
    return localforage.setItem('episodeCount', _item);
  }

  static async setReadEpisodes(storyId, readEpisode) {
    const readEpisodes = await LocalForage.getItem('readEpisodes');

    return localforage
      .setItem('readEpisodes', {
        ...readEpisodes,
        [storyId]: readEpisode,
      })
      .catch((err) => console.error(err));
  }

  static async convertReadEpisodes() {
    const setItems = {};

    Object.keys(localStorage).forEach((key) => {
      if (!key.indexOf('readEpisode')) {
        const storyId = key.split(':')[1];
        const _readEpisode = localStorage.getItem(key) || 0;
        setItems[storyId] = JSON.parse(_readEpisode);
        localStorage.removeItem(key);
      }
    });
    const readEpisodes = await LocalForage.getItem('readEpisodes');
    const _item = {
      ...readEpisodes,
      ...setItems,
    };
    return localforage.setItem('readEpisodes', _item);
  }

  static setDraft(storyId, episodeId, draft) {
    return localforage.getItem(`draft:${storyId}`).then((value) =>
      localforage.setItem(`draft:${storyId}`, {
        ...value,
        [episodeId]: draft,
      })
    );
  }

  static async convertLegacyDraft(storyId, episodeId) {
    if (isNull(localStorage.getItem(`draft:${episodeId}`))) {
      return;
    }

    const legacyDraft = JSON.parse(localStorage.getItem(`draft:${episodeId}`));
    const draft = (await LocalForage.getItem(`draft:${storyId}`)) || {};
    localforage
      .setItem(`draft:${storyId}`, {
        ...draft,
        [episodeId]: legacyDraft,
      })
      .then(() => localStorage.removeItem(`draft:${episodeId}`));
  }

  static async removeItem(key, objKey = null) {
    const value = await localforage.getItem(key);

    if (objKey && value) {
      delete value[objKey];
      if (Object.keys(value).length === 0) {
        return localforage.removeItem(key);
      }
      return localforage.setItem(key, value);
    }
    return localforage.removeItem(key);
  }

  static async getItem(key, objKey = null) {
    const value = await localforage.getItem(key);

    if (typeof value === 'object' && value && objKey !== null) {
      return value[objKey] || null;
    }

    return value;
  }

  static setItem(key, value) {
    return localforage.setItem(key, value);
  }

  static clear() {
    localforage.clear();
  }

  static create() {
    localforage.config({
      name: 'chatieStorage',
    });
  }

  static async convertLegacyAsync() {
    const isLegacyConverted = localStorage.getItem('isLegacyConverted');
    if (!isLegacyConverted) {
      LocalForage.convertEpisodeCount()
        .then(() => LocalForage.convertReadEpisodes())
        .then(() => {
          localStorage.setItem('isLegacyConverted', true);
        })
        .catch((err) => console.error(err));
    }
  }

  static async setFirstViewedDate() {
    const key = 'firstViewedDate';

    const firstViewedDate = await LocalForage.getItem(key);
    if (firstViewedDate) {
      return Promise.resolve(firstViewedDate);
    }

    const date = new Date().getTime();
    return localforage.setItem(key, date).catch((err) => console.error(err));
  }

  static async check() {
    return LocalForage.setItem('storageCheck', uuid.v4());
  }
}

export default LocalForage;



// WEBPACK FOOTER //
// ./src/app/utils/localForage.js